import { useContext } from "react";
import { Home } from "./sample/Home";
import { TeamsFxContext } from "./Context";
import React from "react";

export default function Tab() {
  const { themeString } = useContext(TeamsFxContext);
  return (
    <div
      className={
        themeString === "default"
          ? "light"
          : themeString === "dark"
          ? "dark"
          : "contrast"
      }
    >
      <Home />
    </div>
  );
}
